import * as secondary from "../../../fonts/secondary"

const SecondaryFonts = `
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 100;
  src: local('Poppins Thin'), local('Poppins-Thin'),
  url('${secondary.WOFF2_1}') format("woff2"),
  url('${secondary.WOFF_1}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 100;
  src: local('Poppins Thin Italic'), local('Poppins-ThinItalic'),
  url('${secondary.IWOFF2_1}') format("woff2"),
  url('${secondary.IWOFF_1}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 200;
  src: local('Poppins ExtraLight'), local('Poppins-ExtraLight'),
  url('${secondary.WOFF2_2}') format("woff2"),
  url('${secondary.WOFF_2}') format("woff");
}


@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 200;
  src: local('Poppins ExtraLight Italic'), local('Poppins-ExtraLightItalic'),
  url('${secondary.IWOFF2_2}') format("woff2"),
  url('${secondary.IWOFF_2}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  src: local('Poppins Light'), local('Poppins-Light'),
  url('${secondary.WOFF2_3}') format("woff2"),
  url('${secondary.WOFF_3}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 300;
  src: local('Poppins Light Italic'), local('Poppins-LightItalic'),
  url('${secondary.IWOFF2_3}') format("woff2"),
  url('${secondary.IWOFF_3}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  src: local('Poppins Regular'), local('Poppins-Regular'),
  url('${secondary.WOFF2_4}') format("woff2"),
  url('${secondary.WOFF_4}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 400;
  src: local('Poppins Italic'), local('Poppins-Italic'),
  url('${secondary.IWOFF2_4}') format("woff2"),
  url('${secondary.IWOFF_4}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  src: local('Poppins Medium'), local('Poppins-Medium'),
  url('${secondary.WOFF2_5}') format("woff2"),
  url('${secondary.WOFF_5}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 500;
  src: local('Poppins Medium Italic'), local('Poppins-MediumItalic'),
  url('${secondary.IWOFF2_5}') format("woff2"),
  url('${secondary.IWOFF_5}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  src: local('Poppins SemiBold'), local('Poppins-SemiBold'),
  url('${secondary.WOFF2_6}') format("woff2"),
  url('${secondary.WOFF_6}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 600;
  src: local('Poppins SemiBold Italic'), local('Poppins-SemiBoldItalic'),
  url('${secondary.IWOFF2_6}') format("woff2"),
  url('${secondary.IWOFF_6}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  src: local('Poppins Bold'), local('Poppins-Bold'),
  url('${secondary.WOFF2_7}') format("woff2"),
  url('${secondary.WOFF_7}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 700;
  src: local('Poppins Bold Italic'), local('Poppins-BoldItalic'),
  url('${secondary.IWOFF_7}') format("woff2"),
  url('${secondary.IWOFF2_7}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 800;
  src: local('Poppins ExtraBold'), local('Poppins-ExtraBold'),
  url('${secondary.WOFF2_8}') format("woff2"),
  url('${secondary.WOFF_8}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 800;
  src: local('Poppins ExtraBold Italic'), local('Poppins-ExtraBoldItalic'),
  url('${secondary.IWOFF2_8}') format("woff2"),
  url('${secondary.IWOFF_8}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 900;
  src: local('Poppins Black'), local('Poppins-Black'),
  url('${secondary.WOFF2_9}') format("woff2"),
  url('${secondary.WOFF_9}') format("woff");
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 900;
  src: local('Poppins Black Italic'), local('Poppins-BlackItalic'),
  url('${secondary.IWOFF2_9}') format("woff2"),
  url('${secondary.IWOFF_9}') format("woff");
}




`

export default SecondaryFonts
